import { render, staticRenderFns } from "./NaReport.vue?vue&type=template&id=8cca1a88&scoped=true&"
import script from "./NaReport.vue?vue&type=script&lang=js&"
export * from "./NaReport.vue?vue&type=script&lang=js&"
import style0 from "./NaReport.vue?vue&type=style&index=0&id=8cca1a88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cca1a88",
  null
  
)

export default component.exports